import { Observable } from 'rxjs';

import type { QrMerchantCandidatePage, QrMerchantQuery } from '@app/domain/models/payments-qr/qr-merchant.model';

/**
 * Port del campo "Comercio" del cobro QR: UNA sola operación (RS1).
 *
 * La ventana del QR necesita una lectura — los comercios candidatos — y nada de
 * las otras 16 operaciones de la pasarela (links, cargos, 3DS, alta de
 * comercios, lecturas live). Depender de `PolipayPaymentsRepository` directo
 * le daría a la ventana capacidades que no usa (CLAUDE.md §SOLID-I) y obligaría
 * a sus pruebas a falsear 16 métodos. El adapter de datos es el único que
 * conoce ese port.
 */
export abstract class PaymentQrMerchantsRepository {
  /**
   * Lista los comercios candidatos del alcance del usuario con los filtros del
   * servidor. Falla SIEMPRE con `PaymentQrError` (mismo contrato de error que
   * `PaymentQrRepository`): el consumidor nunca ve un cuerpo del backend.
   */
  abstract listCandidates(query: QrMerchantQuery): Observable<QrMerchantCandidatePage>;
}
